import React from 'react';
import moment from 'moment';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { Button } from 'reactstrap';
import DateFilter from "../../../components/ParadigmaTable/DateFilter";
import NumericFilter from "../../../components/ParadigmaTable/NumericFilter";
import { format } from '../../../functions/functions';
import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable.js";
import api from "../../../api/api.js";
import auth from "../../../auth/auth.js";
import apifunctions from "../../../api/functions";

const columns = [
    {
        Header: "id_deuda",
        id: "id_deuda",
        accessor: "id_deuda",
        show: false,
        private: true,
    },
    {
        Header: "Vencimiento",
        id: "vencimiento",
        accessor: d => moment(d.vencimiento).format('DD/MM/YYYY'),
        className: "text-center",
        show: true,
        width: 100,
        Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
    },
    {
        Header: "Tipo",
        id: "tipo",
        accessor: "tipo",
        width: 100,
        show: true,
        private: true,
    },
    {
        Header: "Plan",
        id: "tipo_venta",
        accessor: (d) => (d.tipo_venta == "C" ? "CONTADO" : (d.tipo_venta == "F" ? "FINANCIADO" : "ESPECIAL")),
        className: "text-center",
        width: 150,
        filterable: true,
        show: true,
        Filter: ({ filter, onChange }) => (
            <select
                onChange={(event) => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : "TODOS"}
            >
                <option value="">TODOS</option>
                <option value={"C"}>CONTADO</option>
                <option value={"F"}>FINANCIADO</option>
                <option value={"E"}>ESPECIAL</option>
            </select>
        ),
    },
    {
        Header: "Loteo",
        id: "loteo_full_name",
        accessor: d => d.loteo_full_name,
        show: false,
        filterable: false
    },
    {
        Header: "Lote",
        id: "lote_full_name",
        accessor: d => d.lote_full_name,
        show: true,
        filterable: false
    },
    {
        Header: "Descripción",
        id: "descripcion",
        accessor: d => d.descripcion,
        show: true,
    },
    {
        Header: "Estado",
        id: "estado",
        accessor: d => d.estado,
        show: true,
    },
    {
        Header: "Monto",
        width: 125,
        id: "monto",
        accessor: d => '$ ' + format(d.monto),
        className: 'text-right',
        show: true,
        Filter: ({ filter, onChange }) => <NumericFilter filter={filter} onChange={onChange} />
    },

]


const getOuterFilter = (filter) => {
    let toReturn = [];
    const { loteoId, desde, hasta } = filter;
    if (loteoId > 0)
        toReturn.push({
            id: 'loteo__id',
            value: {
                lookup: 'exact',
                input: loteoId
            }
        })

    if (desde && hasta) {
        toReturn.push({
            id: 'vencimiento',
            value: {
                lookup: 'range',
                input: `${moment(desde).format('YYYY-MM-DD')},${moment(hasta).format('YYYY-MM-DD')}`,
            }
        });
    }

    return toReturn
}

const ButtonExport = (props) => {

    const paramsExport = () => {

        let parameters = {};

        parameters.fields = columns.map(x => x.id)

        let filters = props.outerFilter.map(filter => {
            const data = filter.value;
            if (typeof data === "object") {
                return (data.lookup != null) ? `${filter.id}[${data.lookup}]=${data.input}` : `${filter.id}=${data.input}`;
            } else if (!data) {
                return;
            } else {
                const column = columns.find(col => col.id === filter.id);
                if (column && column.lookup) {
                    return `${filter.id}[${column.lookup}]=${data}`;
                }
                return filter.id + "[icontains]=" + data;
            }
        }).filter(filter => !!filter);
        if (filters.length > 0) parameters.filters = filters;
        return parameters;
    }

    const exportDeudas = () => {
        let header = auth.header();
        header.responseType = "blob";
        let params = paramsExport();

        let url = apifunctions.generateUrl(api.inversionista.deudas.export, null, 1, params)

        axios.get(
            url, header
        ).then(
            response => {
                if (response.status == 200) {
                    fileDownload(response.data, "Deudas.xls")
                } else {
                    console.log(reponse)
                }
            })
    }

    return (
        <Button
            className={'icon btn-sm h-100 rounded tiny-btn'}
            color={'success'}
            onClick={exportDeudas}
        >
            <i class="fa fa-download fa-lg" />
        </Button>
    );
}


const TablaDeudas = (props) => (
    <ParadigmaTable
        buttons={[
            {
                edit: true,
                component: (p) => <ButtonExport outerFilter={getOuterFilter(props.filter)} />,
                permission: 'inversionista_ingresos',
            },
        ]}
        depth={2}
        apiUrl={api.inversionista.deudas.list}
        columns={columns}
        outerFilter={getOuterFilter(props.filter)}
        title={"Deudas"}
    />
)


export default TablaDeudas;


// WEBPACK FOOTER //
// ./src/views/Inversionistas/Resumen/TablaDeudas.js